if (!customElements.get('auto-field-render')) {

  class AutoFieldRender extends HTMLElement {
    constructor() {
      super();

      this.varSel = null;
      this.selector = null;
      this.prodInfo = null;
      this.wr = null;

      this.locales = this.dataset.localesName;
      this.productForm = this.dataset.productForm;
      this.defaultPreviewText = this.dataset.loacalesPreview;

      // Storage per mantenere i valori durante i rerender
      this.storageKey = `nwt-fields-${this.productForm}`;
      
      
      this.currentColor = localStorage.getItem("nwt-color-chosen");

      this.onChange = this.onChange.bind(this);
      this.onInput = this.onInput.bind(this);
    }

    connectedCallback() {
      this.refreshReferences();
      // console.log('-----');
      // console.log('...connected', this.currentColor);
      
      this.prodInfo?.addEventListener('change', this.onChange);
      this.wr?.addEventListener('input', this.onInput);
      
      this.renderAllFields(this.calcFieldToRender());
      this.wr?.querySelectorAll('.nwt-text-i').forEach(inp => {        
        inp.classList.toggle("has-value", inp.value.trim() !== "");
      });

      this.allPreviews = this.wr?.querySelectorAll('.nwt-text-preview');
      document.addEventListener("color-change", this.onColorChange);
    }
    
    disconnectedCallback() {
      this.prodInfo?.removeEventListener('change', this.onChange);
      this.wr?.removeEventListener('input', this.onInput);
      document.removeEventListener("color-change", this.onColorChange)
    }

    refreshReferences() {
      this.varSel = this.closest('variant-selects');
      this.selector = this.varSel?.querySelector('.nwt-dropill');
      this.prodInfo = this.varSel?.closest('product-info');
      this.wr = this.prodInfo?.querySelector('.nwt-fields-wr');
    }

    onColorChange = (e) => {
      if (!this.prodInfo?.contains(e.detail.radio)) return;

      this.currentColor = e.detail.value;
      this.applyPreviewColor(this.currentColor);
    };

    applyPreviewColor(color) {
      if (!this.wr || !color) return;
      localStorage.setItem("nwt-color-chosen", color);
      this.wr.querySelectorAll('.nwt-text-preview').forEach(preview => {
        preview.style.color = color;
        // console.log('set color', color, preview.style.color);
      });

      
    }

    onInput(e) {
      // console.log('....onInput',e);
      if (!e.target.matches('.nwt-text-i')) return;

      sessionStorage.setItem(
        `${this.storageKey}-${e.target.name}`,
        e.target.value
      );

      

      const preview = e.target
        .closest('.nwt-text-in-wr')
        ?.querySelector('.nwt-text-preview');

      e.target.classList.toggle("has-value", e.target.value.trim() !== "");

      const counter = e.target
        .closest('.nwt-t-input')
        ?.querySelector('.nwt-char-count');

      if (preview) preview.textContent = e.target.value;
      if (counter) counter.textContent = `${e.target.value.length}/12`;
    }

    onChange(e) {
      this.refreshReferences();

      if (!e.target.matches('.nwt-dropPill-input')) return;

      this.renderAllFields(this.calcFieldToRender(e.target));
    }

    calcFieldToRender(input = null) {
      if (input) {
        return Number(input.dataset.index);
      }

      const checked = this.selector?.querySelector('.nwt-dropPill-input:checked');

      return checked ? Number(checked.dataset.index) : 0;
    }

    renderField(index) {
      const template = document.createElement('template');
      
      

      const name = `properties[${this.locales} #${index}]`;
      const value = sessionStorage.getItem(`${this.storageKey}-${name}`) || '';

      template.innerHTML = `
        <nwt-text-in-main class="flex flex-col">
          <div class="nwt-text-in-wr flex">
            <div class="nwt-t-input flex rel">
              <input
                class="nwt-text-i"
                type="text"
                name="${name}"
                value="${value}"
                form="${this.productForm}"
                size="12"
                maxlength="12"
                placeholder="${this.locales} #${index}">
              <span class="nwt-char-count abs">${value.length}/12</span>
            </div>
            <div class="nwt-text-preview">${value == '' ? this.defaultPreviewText : value}</div>
          </div>
        </nwt-text-in-main>
      `;
      // template.innerHTML = `
      //   <nwt-text-in-main class="flex flex-col">
      //     <div class="nwt-text-in-wr flex">
      //       <div class="nwt-t-input flex rel">
      //         <input
      //           class="nwt-text-i"
      //           type="text"
      //           name="${name}"
      //           value="${value}"
      //           form="${this.productForm}"
      //           size="12"
      //           maxlength="12"
      //           placeholder="${this.locales} #${index}">
      //         <span class="nwt-char-count abs">${value.length}/12</span>
      //       </div>
      //     </div>
      //   </nwt-text-in-main>
      // `;

      // console.log('renderField ',template);

      return template.content.firstElementChild;
    }

    renderAllFields(qty) {
      if (!this.wr) return;

      this.wr.replaceChildren();

      for (let i = 1; i <= qty; i++) {
        this.wr.appendChild(this.renderField(i));
      }

      if (this.currentColor) {
        this.applyPreviewColor(this.currentColor);
      }
    }
  }

  customElements.define('auto-field-render', AutoFieldRender);
}